require("./src/assets/scss/global.scss")

exports.onRouteUpdate = ({ location }) => {
  if (location.hash) {
    setTimeout(() => {
      document.querySelector(`${location.hash}`).scrollIntoView()
    }, 420)
  }
}

exports.onServiceWorkerUpdateReady = () => {
  window.location.reload()
}
